"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    default: function() {
        return _default;
    },
    Modal: function() {
        return Modal;
    }
});
var _eventHandlers = require("./eventHandlers");
var _backdrop = require("../Backdrop");
var _helpers = require("./helpers");
var _router = require("../Router");
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var defaults = {
    attributes: true,
    closeOnEsc: false
};
/**
 * Extend this class to create your own modal.
 */ var Modal = /*#__PURE__*/ function() {
    "use strict";
    function Modal(selector) {
        var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        _classCallCheck(this, Modal);
        this.on = function() {};
        this.fire = function() {};
        this.modal = this.getElement(selector);
        this.accelerator = new _router.Accelerator();
        this.config = Object.assign({}, defaults, config);
        if (this.config.button) {
            this.setButton(this.config.button);
        }
        this.backdrop = _backdrop.Backdrop.getInstance();
        this.openModal = _eventHandlers.openModal.bind(this);
        this.closeModal = _eventHandlers.closeModal.bind(this);
        this.isModalOpen = _helpers.isModalOpen.bind(this);
        this.on = this.accelerator.subscribe.bind(this.accelerator);
        this.fire = this.accelerator.publish.bind(this.accelerator);
        this.modal.Modal = this;
        this.addEventListeners();
    }
    var _proto = Modal.prototype;
    _proto.addEventListeners = function addEventListeners() {
        var _this = this;
        this.backdrop.on("click", this.close.bind(this));
        this.on("show", this.open.bind(this));
        this.on("hide", this.close.bind(this));
        if (this.config.closeOnEsc) {
            document.addEventListener("keydown", function(e) {
                if (e.key === "Escape") {
                    _this.fire("hide");
                }
            });
        }
        /**
         * @deprecated 1.0.0 in favor of pubsub
         */ this.modal.addEventListener("wr-modal-show", function() {
            return _this.modal.Modal.open();
        });
        /**
         * @deprecated 1.0.0 in favor of pubsub
         */ this.modal.addEventListener("wr-modal-hide", function() {
            return _this.modal.Modal.close();
        });
    };
    _proto.openFromButton = function openFromButton(modal, button) {
        this.modal = this.getElement(modal);
        this.button = this.getElement(button);
        if (this.handleButtonClick) {
            var _this_button;
            (_this_button = this.button) === null || _this_button === void 0 ? void 0 : _this_button.addEventListener("click", this.handleButtonClick.bind(this));
        }
    };
    _proto.open = function open() {
        this.openModal();
        this.fire("open", {
            Modal: this
        });
    };
    _proto.close = function close() {
        this.closeModal();
        this.fire("close", {
            Modal: this
        });
    };
    _proto.getElement = function getElement(selectorOrHTMLElement) {
        if (typeof selectorOrHTMLElement === "string") {
            return document.querySelector(selectorOrHTMLElement);
        }
        return selectorOrHTMLElement;
    };
    _proto.setButton = function setButton(button) {
        this.button = this.getElement(button);
        this.handleButtonClick = _eventHandlers.handleButtonClick.bind(this);
        this.button.addEventListener("click", this.handleButtonClick.bind(this));
    };
    Modal.open = function open(modal, config) {
        var ModalObj = new Modal(modal, config);
        ModalObj.open();
    };
    Modal.close = function close(modal, config) {
        var ModalObj = new Modal(modal, config);
        ModalObj.close();
    };
    return Modal;
}();
var _default = Modal;
